import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { classNames, textClassNames } from '../atoms';
import type { LayoutClassNameProps, TextClassNameProps } from '../atoms';
import {
  type FlexAlign,
  type FlexDirection,
  type FlexDirectionAt,
  type FlexGap,
  type FlexJustify,
  type FlexWrap,
  getFlexClassName,
} from './Flex';

export interface FlexLinkProps extends LinkProps, LayoutClassNameProps, TextClassNameProps {
  align?: FlexAlign;
  direction?: FlexDirection;
  directionAt?: FlexDirectionAt;
  flexGrow?: boolean;
  fullHeight?: boolean;
  fullWidth?: boolean;
  gap?: FlexGap;
  justify?: FlexJustify;
  wrap?: FlexWrap;
}

const FlexLink = React.forwardRef<HTMLAnchorElement, FlexLinkProps>(({
  align,
  className,
  children,
  direction = 'row',
  directionAt,
  flexGrow = false,
  fullHeight = false,
  fullWidth = false,
  gap,
  justify,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  textColor,
  textDecoration,
  textReset = false,
  wrap,
  ...props
}, ref) => (
  <Link
    ref={ref}
    className={getFlexClassName({
      align,
      className: classNames(
        flexGrow ? 'flex-grow-1' : undefined,
        textClassNames({
          textColor,
          textDecoration,
          textReset,
        }),
        className,
      ),
      direction,
      directionAt,
      fullHeight,
      fullWidth,
      gap,
      justify,
      margin,
      marginTop,
      marginEnd,
      marginBottom,
      marginStart,
      marginX,
      marginY,
      padding,
      paddingTop,
      paddingEnd,
      paddingBottom,
      paddingStart,
      paddingX,
      paddingY,
      textAlign,
      wrap,
    })}
    {...props}
  >
    {children}
  </Link>
));

FlexLink.displayName = 'FlexLink';

export default FlexLink;
